/**
 * Audit Event Emitter Service
 *
 * Fire-and-forget POST to /settings/api/v1/audit.
 * Never blocks UI — errors are silently caught.
 */
import type { AuditLogRequest } from '@tms-phoenix/tms-types';
import { API_ROUTES } from '@/core/config';
import { getApiClient } from './api.service';

type RequiredAuditFields = Pick<AuditLogRequest, 'eventCategory' | 'eventType' | 'eventStatus'>;
type AuditLogPayload = RequiredAuditFields & Partial<AuditLogRequest>;

/**
 * Emit an audit event to the backend.
 * This must never interrupt app flow.
 */
export function logAuditEvent(payload: AuditLogPayload): void {
  try {
    const api = getApiClient();
    api.post(`${API_ROUTES.SETTINGS}/audit`, payload).catch(() => {
      // Silent — audit failures must never impact UX
    });
  } catch {
    // Guard against getApiClient() throwing before auth is ready
  }
}
